"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileExtension = void 0;

var getFileExtension = function getFileExtension(fileName) {
  if (!fileName.includes(".")) {
    return "";
  }

  return fileName.split(".").slice(-1)[0];
};

exports.getFileExtension = getFileExtension;